import { __extends, __makeTemplateObject, __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit-element/lit-element.js';
import { ifDefined } from '../../node_modules/lit-html/directives/if-defined.js';
import { Slotify } from '../../node_modules/@eightshapes/slotify/src/slotify.js';
import customElement from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/decorators/custom-element.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { html } from '../../node_modules/lit-html/lit-html.js';
import { property } from '../../node_modules/lit-element/lib/decorators.js';

/**
 * Providence Microcopy component.
 * @see {@link https://providence.fmr.com/components/microcopy/microcopy.html|Microcopy documentation}
 */
var CustomElementMixin = customElement({
    name: 'microcopy',
    namespace: 'pvd',
});
var PvdMicrocopy = /** @class */ (function (_super) {
    __extends(PvdMicrocopy, _super);
    function PvdMicrocopy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PvdMicrocopy.prototype, "hasText", {
        // #endregion
        // #region private methods
        get: function () {
            return !!this.pvdText || this.isSlotUsed();
        },
        enumerable: true,
        configurable: true
    });
    //#endregion
    // #region LitElement lifecycles
    PvdMicrocopy.prototype.render = function () {
        var classMap = {
            // @ts-ignore
            default: this.constructor.namespace + "-microcopy-root",
            modifierPrefix: 'pvd-microcopy',
            modifiers: [],
        };
        return html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      <div class=\"", "\" id=\"", "\">\n        ", "\n      </div>\n    "], ["\n      <div class=\"", "\" id=\"", "\">\n        ",
            "\n      </div>\n    "])), getClassName(classMap), ifDefined(this.pvdId), this.hasText
            ? html(templateObject_1 || (templateObject_1 = __makeTemplateObject([" <p class=\"pvd-microcopy__microcopy\"><s-slot>", "</s-slot></p> "], [" <p class=\"pvd-microcopy__microcopy\"><s-slot>", "</s-slot></p> "])), this.pvdText) : html(templateObject_2 || (templateObject_2 = __makeTemplateObject([" <s-slot></s-slot> "], [" <s-slot></s-slot> "]))));
    };
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-id' }),
        __metadata("design:type", String)
    ], PvdMicrocopy.prototype, "pvdId", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-text' }),
        __metadata("design:type", String)
    ], PvdMicrocopy.prototype, "pvdText", void 0);
    return PvdMicrocopy;
}(CustomElementMixin(Slotify(PvdSlotifyBaseComponent))));
var templateObject_1, templateObject_2, templateObject_3;

export { PvdMicrocopy };
